export default {
  employees: "Кассиры",
  noCreatedYet: "Кассиры еще не созданы",
  downloadAppRCKassa: "Скачать приложение RC KASSA",
  downloadRCKassa: "Скачать RC KASSA",
  addingEmployee: "Добавление кассира",
  toCreateEmployeeNeedPoint:
    "Для создания кассира необходима хотя бы одна торговая точка",
  secondName: "Фамилия кассира",
  firstName: "Имя кассира",
  toTradingPoints: "К торговым точкам",
  uWantToDeleteEmployee: "Вы уверены что хотите удалить кассира?",
  personName: "Фамилия и Имя",
  blockAccess: "Заблокировать доступ",
  openAccess: "Открыть доступ",

  employeeScore: "Очки кассирам",
  points: "очков",
  debiting: "Списание",
  accrual: "Начисление",

  enterPointsAmount:
    "Введите количество очков, которые будут получать кассиры за проведение операций по начислению баллов клиентам",
  forRealClientsOperations: "За операции существующих клиентов",
  forNewClientsOperation: "За операции новых клиентов",
  toSetPointsNeedBuyTariff:
    "Чтобы проставлять очки кассирам, необходимо приобрести тариф «Промо» или «Про+»",
};
